import type { SkeletonLoaderOptions } from '@ui/skeleton-loader/skeleton-loader-props';
import { PropsWithChildren, CSSProperties } from 'react';

export const HoverCardExternalTriggerClass = 'hover-card-external-trigger';

export type HoverCardProps = PropsWithChildren<{
  containerClassName?: string;
  height?: string;
  width?: string;
  aspectRatio?: CSSProperties['aspectRatio'];
  borderRadius?: CSSProperties['borderRadius'];
  hoverOnTab?: boolean;
  backgroundColor?: string;
  hoverBackgroundColor?: string;
  backgroundImg?: string;
  type?: 'fade' | 'slide';
  preHoverContentSlide?: boolean;
  /** duration in ms */
  duration?: number;
  /** delay in ms */
  delay?: number;
  disableHover?: boolean;
  hasExternalTrigger?: boolean;
  /** forceHoverState will trigger the hover state */
  forceHoverState?: boolean;
  skLoader?: SkeletonLoaderOptions;
  tabIndex?: number;
}>;

export type PreHoverContentProps = PropsWithChildren<{
  backgroundImage?: string | null;
  backgroundSize?: 'cover' | 'contain';
  backgroundColor?: string;
}>;

export type HoverContentProps = PropsWithChildren<{
  backgroundColor?: string;
  backdropFilter?: CSSProperties['backdropFilter'];
}>;
